import { jwtDecode } from "jwt-decode";
import { LOGIN_SUCCESS, LOGOUT } from "../actions";

const storedToken = localStorage.getItem("accessToken");

const restoreSession = () => {
  if (!storedToken) return { token: null, user: null };
  try {
    const user = jwtDecode(storedToken);
    if (user.exp && user.exp <= Date.now() / 1000) throw new Error("Expired token");
    return { token: storedToken, user };
  } catch {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    return { token: null, user: null };
  }
};

const restoredSession = restoreSession();

const initialState = {
  token: restoredSession.token,
  isAuthenticated: Boolean(restoredSession.token),
  user: restoredSession.user,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
        isAuthenticated: true,
        user: jwtDecode(action.payload.token),
      };
    case LOGOUT:
      return {
        ...state,
        token: null,
        refreshToken: null,
        isAuthenticated: false,
        user: null,
      };
    default:
      return state;
  }
};

export default authReducer;
